export default __webpack_public_path__ + "static/media/our-history.8392c224.jpg";